import { store } from '@betacrew/jars-flux'
import { PAGE_STATE } from '../../../constants/constants';

export const componentKey = "FORMS/REVIEW_REJECTED_FORMS/1099_FORMS"

const { actions } = store.reducerManager.add({
    key: componentKey,
    addedReducers: {
        setLoadingState: (state, action) => {
            state.loadingState = action.payload;
        },

        setFormList: (state, action) => {
            state.formList = action.payload;
        },

        setSelectedForm: (state, action) => {
            state.selectedForm = action.payload;
        },

        setTaxYearList: (state, action) => {
            state.taxYearList = action.payload;
        },

        setSelectedTaxYear: (state, action) => {
            state.selectedTaxYear = action.payload;
        },

        setPayersList: (state, action) => {
            state.payersList = action.payload;
        },

        setSelectedPayer: (state, action) => {
            state.selectedPayer = action.payload;
        },

        setRejected1099FormsGrid: (state, action) => {
            state.rejected1099FormsGrid = action.payload;
        },

        setSelectedRejected1099Forms: (state, action) => {
            state.selectedRejected1099Forms = action.payload;
        },

        setPaginationState: (state, action) => {
            state.paginationState = { ...state.paginationState, ...action.payload }
        },

        setDeleteRejectedFormModal: (state, action) => {
            state.deleteRejectedFormModal = action.payload;
        },

        setClickedFormDetails: (state, action) => {
            state.clickedFormDetails = action.payload;
        },

        setGridDataLoadingState: (state, action) => {
            state.gridDataLoadingState = action.payload;
        },
        setPayerListLoadingState: (state, action) => {
            state.payerListLoadingState = action.payload;
        },
        setPayerDropdownPagination: (state, action) => {
            state.payerDropdownPagination = { ...state.payerDropdownPagination, ...action.payload }
        },
    },
    initialReducerState: {
        loadingState: { state: PAGE_STATE.PAGE_READY, message: "" },
        gridDataLoadingState: { state: PAGE_STATE.PAGE_READY, message: "" },
        payerListLoadingState: { state: PAGE_STATE.PAGE_READY, message: "" },

        //Filters
        formList: [],
        selectedForm: { label: "", value: "" },

        taxYearList: [],
        selectedTaxYear: { label: "", value: "" },

        payersList: [],
        selectedPayer: { label: "", value: "" },

        //Grid
        rejected1099FormsGrid: [],
        selectedRejected1099Forms: [],

        paginationState: {
            PageNumber: 1,
            PageSize: 5,
            FilterText: "",
            IsDesc: true,
            IdNumber: "",
            Skip: 0,
            total: 5,
        },

        payerDropdownPagination: {
            PageNumber: 1,
            PageSize: 10,
        },

        clickedFormDetails: {}, 

        //Modals
        deleteRejectedFormModal: false,
    }
})

export const { setLoadingState, setFormList, setSelectedForm, setTaxYearList, setSelectedTaxYear, setPayersList, setSelectedPayer, setRejected1099FormsGrid, setSelectedRejected1099Forms, setPaginationState, setDeleteRejectedFormModal, setClickedFormDetails, setGridDataLoadingState, setPayerListLoadingState, setPayerDropdownPagination } = actions;
